export enum FontSizes {
  xs = 'xs', // 0.875rem (14px)
  sm = 'sm', // 1.125rem (18px)
  md = 'md', // 1.5rem (24px)
  lg = 'lg', // 2.25rem (36px)
  xl = 'xl', // 3rem (48px)
  xxl = 'xxl', // 4.5rem (72px)
}

export enum Fonts {
  GT_EESTI_DISPLAY = 'gt-eesti-display',
  SPECTRAL = 'spectral',
}
